import mqtt, { MqttClient } from 'precompiled-mqtt';
import { getAccessToken } from 'src/lib/api-client';

import { ISessionEvent, SessionEventTypes } from '../../../event-stack';
import { getPlayerState } from '../../utilities';

let client: MqttClient;
const MQTT_PASSWORD = process.env.REACT_APP_PW_MQTT_PASSWORD;

const mqttConnect = (host: any, mqttOption: any) => {
  // @ts-ignore
  const player = window.player;
  const event: ISessionEvent = {
    type: SessionEventTypes.MQTTConnectionAttepmt,
    data: {
      timestamp: new Date().toLocaleString(),
      description: 'MQTT Connection Attempt',
      videoDuration: player?.currentTime(),
      videoState: getPlayerState(),
      data: {
        ...mqttOption,
        keepalive: 3000,
        clean: true,
        connectTimeout: 3000, // connection timeout in 3sec
        reconnectPeriod: 3000, // will reconnect in 3sec
        clientId: `mqtt-web-client-${new Date().getTime()}`,
        password: MQTT_PASSWORD,
        username: `${getAccessToken()}-${new Date().getTime()}`,
      },
    },
  };
  // SessionEventrecord(event);
  mqttOption = {
    ...mqttOption,
    keepalive: 3000,
    clean: true,
    connectTimeout: 3000, // connection timeout in 3sec
    reconnectPeriod: 3000, // will reconnect in 3sec
    clientId: `mqtt-web-client-${new Date().getTime()}`,
    password: MQTT_PASSWORD,
    username: `${getAccessToken()}-${new Date().getTime()}`,
  };
  client = mqtt.connect(host, mqttOption);
  client.on('connect', () => {
    console.log('CONNECTED to mqtt broker');
  });

  client.on('error', () => {
    console.log('ERROR while connecting to mqtt broker');
  });
};

const mqttSub = (client: MqttClient, subscription: any, onDataReceived: any) => {
  if (client) {
    const { topic, qos } = subscription;
    client.subscribe(topic, { qos }, (error: any, granted: any) => {
      if (error) {
        console.log('ERROR in subscription', error);
        return;
      } else {
        console.log('GRANTED>>>', granted);
      }
    });
    client.on('message', (topic: any, message: any) => {
      onDataReceived({ topic: topic, data: message });
    });
  }
};

const mqttUnSub = (client: any, subscription: any, setIsSub: any) => {
  if (client) {
    const { topic } = subscription;
    client.unsubscribe(topic, (error: any) => {
      if (error) {
        console.log('Unsubscribe error', error);
        return;
      }

      if (setIsSub) {
        setIsSub(false);
      }
    });
  }
};

const mqttDisconnect = (client: any, setConnectStatus: any) => {
  if (client) {
    client.end(() => {
      // @ts-ignore
      const player = window.player;
      const event: ISessionEvent = {
        type: SessionEventTypes.MQTTConnectionLost,
        data: {
          timestamp: new Date().toLocaleString(),
          description: 'MQTT Connection Disconnect',
          videoDuration: player?.currentTime(),
          videoState: getPlayerState(),
          data: {},
        },
      };
      // SessionEventrecord(event);
      setConnectStatus('DisConnect');
    });
  }
};

const createMqttService = () => {
  return {
    get client() {
      return client;
    },
    connect: mqttConnect,
    subscribe: (subscription: any, onDataReceived: any) =>
      mqttSub(client, subscription, onDataReceived),
    unsubscribe: (subscription: any, setIsSub: any) => mqttUnSub(client, subscription, setIsSub),
    disconnect: (setConnectStatus: any) => mqttDisconnect(client, setConnectStatus),
  };
};

export default createMqttService;

export enum OPERATION {
  START = 'start',
  STOP = 'stop',
  RESULT = 'result',
  STOP_EXPIRY = 'stop_expiry',
  ATTEMPT = 'attempt',
}
